module.exports = __webpack_public_path__ + "img/coinbase-advanced-trading-chart.1cc0d3e4.webp";